import { MockedRoomControlFeatures } from './operational-data.RoomControl-1.mocks';
import { MockedVitoairFeatures } from './operational-data.Vitoair.mocks';
import { MockedVitocal200SFeatures } from './operational-data.Vitocal-200-S.mocks';
import { MockedVitocal222SFeatures } from './operational-data.Vitocal-222-S.mocks';
import { MockedVitocal252AMpkFeatures } from './operational-data.Vitocal-252-A-MPK.mocks';
import { MockedVitocal252ACascadeFeatures } from './operational-data.Vitocal-252-A-Cascade.mocks';
import { MockedVitochargeFeatures } from './operational-data.Vitocharge.mocks';
import { MockedVitodens100WFeatures } from './operational-data.Vitodens-100-W.mocks';
import { MockedVitodens200Features } from './operational-data.Vitodens-200.mocks';
import { MockedVitodens300Features } from './operational-data.Vitodens-300.mocks';
import { MockedVitodens343FFeatures } from './operational-data.Vitodens-343-F.mocks';
import { MockedVitoligno300CFeatures } from './operational-data.Vitoligno-300-C.mocks';
import { MockedVitovalorPT2Features } from './operational-data.Vitovalor-PT2.mocks';
import { MockedGatewayFeatures } from './operational-data.gateway.mocks';
import { MockedHemsFeatures } from './operational-data.hems.mocks';
import { DcFeatures } from './operational-data.model';
import { MockedVitocal250AFeatures } from './operational-data.Vitocal-250-A.mocks';
import { MockedVitosetAquaFeatures } from './operational-data.VitosetAqua.mocks';

export class MockedDevicesFeatures {
  mock(installationId: number, gatewaySerial: string): DcFeatures {
    let features = [];

    // gateway 7637415-gw-serial-7 has Offline status
    // gateway 7637415-gw-serial-8 has Maintenance status
    // for these gateways we should not call gateway features
    if (gatewaySerial !== '7637415-gw-serial-7' && gatewaySerial !== '7637415-gw-serial-8') {
      features = features.concat(new MockedGatewayFeatures().mock(installationId, gatewaySerial));
    }

    switch (gatewaySerial) {
      case '7736170-gw-serial-17':
        features = features.concat(
          new MockedVitocal252ACascadeFeatures().mock(installationId, gatewaySerial),
          new MockedHemsFeatures().mock(installationId, gatewaySerial),
          new MockedRoomControlFeatures().mock(installationId, gatewaySerial)
        );
        break;

      case '7637415001667188':
        features = features.concat(
          new MockedVitodens300Features().mock(installationId, gatewaySerial),
          new MockedRoomControlFeatures().mock(installationId, gatewaySerial)
        );
        break;

      case '7637416-gw-serial':
        features = features.concat(
          new MockedVitocal252AMpkFeatures().mock(installationId, gatewaySerial),
          new MockedHemsFeatures().mock(installationId, gatewaySerial)
        );
        break;

      case '7637410-gw-serial-16':
        features = features.concat(
          new MockedVitocal222SFeatures().mock(installationId, gatewaySerial),
          new MockedHemsFeatures().mock(installationId, gatewaySerial)
        );
        break;

      case '7724820-gw-serial-18':
        features = features.concat(
          new MockedVitodens200Features().mock(installationId, gatewaySerial)
        );
        break;

      case '7571381-gw-serial':
        features = features.concat(
          new MockedVitodens300Features().mock(installationId, gatewaySerial)
        );
        break;

      case '7637415-gw-serial':
      case '7637419-gw-serial':
        features = features.concat(
          new MockedVitocal200SFeatures().mock(installationId, gatewaySerial)
        );
        break;

      case '7782093-gw-serial':
        features = features.concat(
          new MockedVitovalorPT2Features().mock(installationId, gatewaySerial)
        );
        break;

      case '7571381-gw-serial-4':
        features = features.concat(
          new MockedVitodens343FFeatures().mock(installationId, gatewaySerial)
        );
        break;

      case '7637414-gw-serial':
        features = features.concat(
          new MockedVitodens100WFeatures().mock(installationId, gatewaySerial)
        );
        break;

      case '7724827-gw-serial':
        features = features.concat(
          new MockedVitochargeFeatures().mock(installationId, gatewaySerial),
          new MockedHemsFeatures().mock(installationId, gatewaySerial)
        );
        break;

      case '77820930-gw-serial-10':
        features = features.concat(
          new MockedVitochargeFeatures().mock(installationId, gatewaySerial)
        );
        break;

      case '7637221-gw-serial-11':
        features = features.concat(
          new MockedVitoligno300CFeatures().mock(installationId, gatewaySerial)
        );
        break;

      case '7949720-gw-serial-14':
        features = features.concat(new MockedVitoairFeatures().mock(installationId, gatewaySerial));
        break;

      case '7736172-gw-serial-12':
        features = features.concat(
          new MockedVitocal250AFeatures().mock(installationId, gatewaySerial)
        );
        break;

      case '7949719-gw-serial-12':
        features = features.concat(
          new MockedVitosetAquaFeatures().mock(installationId, gatewaySerial)
        );
        break;

      default:
        break;
    }

    return { data: features };
  }
}
